/* WIM · Rediseño UX TucTuc — JS mínimo, sin dependencias. Solo se carga con el rediseño activo. */
(function () {
  'use strict';

  /* Tarjeta: botones de talla y «+» → fija la variante y envía el formulario del tema (product-form) */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wim-variant]');
    if (!button || button.disabled) return;
    var form = button.closest('form');
    if (!form || !form.elements.id) return;
    event.preventDefault();
    form.elements.id.value = button.getAttribute('data-wim-variant');
    button.classList.add('is-adding');
    setTimeout(function () { button.classList.remove('is-adding'); }, 1500);
    if (form.requestSubmit) { form.requestSubmit(); } else { form.dispatchEvent(new Event('submit', { cancelable: true })); }
  });
})();

/* PLP: entradilla de 2 líneas con «Leer más» */
(function () {
  'use strict';
  function initClamp(root) {
    root.querySelectorAll('[data-wim-clamp]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var text = box.querySelector('.wim-plp-head__intro-text');
      var btn = box.querySelector('.wim-plp-head__more');
      if (!text || !btn) return;
      if (text.scrollHeight > text.clientHeight + 2) btn.hidden = false;
      var more = btn.textContent;
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
        btn.textContent = open ? (btn.dataset.less || more) : more;
      });
    });
  }
  if (document.readyState !== 'loading') initClamp(document); else document.addEventListener('DOMContentLoaded', function () { initClamp(document); });
})();

/* PLP: «Ver más productos» añade la página siguiente sin recargar (Section Rendering API).
   El enlace es real (rel=next): sin JS o si falla, navega a la página 2 como siempre. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-wim-next]');
    if (!link) return;
    var progress = link.closest('[data-wim-progress]');
    var list = document.querySelector('#collection product-list');
    if (!progress || !list || !window.fetch || !window.DOMParser) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    var url = new URL(link.href, location.href);
    url.searchParams.set('section_id', progress.getAttribute('data-section-id'));
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newList = doc.querySelector('#collection product-list');
        var newProgress = doc.querySelector('[data-wim-progress]');
        if (!newList || !newProgress) throw new Error('markup');
        var firstNew = null;
        Array.from(newList.children).forEach(function (child) {
          if (child.classList.contains('product-list__promo')) return;
          child.removeAttribute('reveal-on-scroll');
          var node = document.importNode(child, true);
          if (!firstNew) firstNew = node;
          list.appendChild(node);
        });
        progress.replaceWith(document.importNode(newProgress, true));
        var pagination = document.querySelector('#collection .pagination');
        var newPagination = doc.querySelector('#collection .pagination');
        if (pagination && newPagination) pagination.replaceWith(document.importNode(newPagination, true));
        if (firstNew) {
          var focusable = firstNew.querySelector('a[href]:not([tabindex="-1"])');
          if (focusable) focusable.focus({ preventScroll: true });
        }
      })
      .catch(function () { window.location.href = link.href; });
  });
})();

/* Pestañas genéricas: [data-wim-tabs] > [role=tab][aria-controls] (home «Productos con pestañas») */
(function () {
  'use strict';
  function select(tab) {
    var list = tab.closest('[data-wim-tabs]');
    list.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-wim-tabs] [role="tab"]');
    if (tab) select(tab);
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest('[data-wim-tabs] [role="tab"]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.from(tab.closest('[data-wim-tabs]').querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = tabs[(i + tabs.length) % tabs.length];
    select(next); next.focus(); e.preventDefault();
  });
})();

/* Pie: columnas como acordeón en móvil (la primera abierta) y siempre abiertas en escritorio */
(function () {
  'use strict';
  var mq = window.matchMedia('(min-width: 1000px)');
  function apply() {
    var cols = document.querySelectorAll('details.wim-fcol');
    cols.forEach(function (d, i) { d.open = mq.matches || i === 0; });
  }
  if (document.readyState !== 'loading') apply(); else document.addEventListener('DOMContentLoaded', apply);
  if (mq.addEventListener) mq.addEventListener('change', apply);
  document.addEventListener('click', function (e) {
    var s = e.target.closest('details.wim-fcol > summary');
    if (s && mq.matches) e.preventDefault(); /* en escritorio no se pliegan */
  });
})();

/* Pie: las garantías van antes de la banda de newsletter, como en el prototipo (son secciones distintas) */
(function () {
  'use strict';
  function move() {
    var badges = document.querySelector('.tt-badges');
    var band = document.querySelector('.shopify-section--wim-nlapp');
    if (badges && band && !badges.dataset.wimMoved) {
      badges.dataset.wimMoved = '1';
      band.parentNode.insertBefore(badges, band);
    }
  }
  if (document.readyState !== 'loading') move(); else document.addEventListener('DOMContentLoaded', move);
})();

/* Listado: filtros rápidos. El botón abre el panel de filtros del tema (aria-controls) y aquí se despliega
   solo el filtro pulsado y se lleva a la vista. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wim-filter]');
    if (!btn) return;
    var label = (btn.getAttribute('data-wim-filter') || '').trim().toLowerCase();
    var tries = 0;
    (function focusFilter() {
      var drawer = document.getElementById('facets-drawer');
      var all = drawer ? drawer.querySelectorAll('details.accordion__disclosure') : [];
      var target = null;
      all.forEach(function (d) {
        var s = d.querySelector('summary');
        if (s && s.textContent.trim().toLowerCase() === label) target = d;
      });
      if (!target && tries++ < 10) { setTimeout(focusFilter, 80); return; }
      if (!target) return;
      all.forEach(function (d) { d.open = d === target; });
      setTimeout(function () {
        target.scrollIntoView({ block: 'start', behavior: 'smooth' });
        var first = target.querySelector('input, button, a');
        if (first) first.focus({ preventScroll: true });
      }, 250);
    })();
  });
})();

/* Listado: el nº de productos junto al H1 se actualiza al filtrar (el tema solo recarga la sección de productos) */
(function () {
  'use strict';
  function sync() {
    var head = document.querySelector('.wim-plp-head__count');
    var src = document.querySelector('#collection .collection__toolbar > .subheading:first-child');
    if (head && src && src.textContent.trim() && head.textContent.trim() !== src.textContent.trim()) {
      head.textContent = src.textContent.trim();
    }
  }
  function init() {
    var root = document.getElementById('collection');
    if (!root || !document.querySelector('.wim-plp-head__count')) return;
    sync();
    var section = root.closest('.shopify-section') || root.parentNode;
    new MutationObserver(sync).observe(section, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* Ayuda de talla: en móvil empieza plegada para que los botones de talla y «Añadir a la cesta» queden más arriba */
(function () {
  function run() {
    if (!window.matchMedia('(max-width: 699px)').matches) return;
    document.querySelectorAll('.wim-size-helper__details[open]').forEach(function (d) { d.removeAttribute('open'); });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
